<template>
  <v-container>
    <div v-if="urls == null || urls.length == 0">
      <v-row class="ma-0" align="center" justify="center">
        <v-icon class="mx-auto" color="#E1E2E6" size="200px">mdi-link</v-icon>
      </v-row>
      <v-row class="ma-0" align="center" justify="center">
        <div class="font-weight-bold no-data">ไม่มีลิงก์ให้แสดง</div>
      </v-row>
    </div>
    <div v-if="urls !== null && urls.length>0">
      <div class="mb-4" v-for="url in urls" :key="url._id">
        <div class="font-weight-bold">{{url.title}}</div>
        <v-row>
          <v-col :cols="8" :lg="10" :md="10" :sm="8">
            <div class="box">
              <a @click="openNewWeb(url.url)">{{url.url}}</a>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  props: {
    urls: {
      type: Array
    },
  },
  async mounted() {},
  methods: {
    openNewWeb(url) {
      window.open(
        url,
        "vuetifyjs",
        "resizable,scrollbars,status,width=1000,height=700"
      );
    }
  }
};
</script>
<style scoped>
.description {
  font-size: 16px;
}
.no-data {
  color: #E1E2E6;
}
.chat-avatar {
  padding: 10px 10px 10px 0px;
  display: inline-table;
}
.chat-message {
  padding: 10px;
  display: inline-table;
  font-size: 16px;
  /* width: 50px; */
}
.box-disable {
  background-color: #f4f4f4;
  vertical-align: center;
  width: 100%;
  height: 100%;
  margin: auto;
  /* width: 60%; */
  /* border: 3px solid #73AD21; */
  padding: 6px;
}
.white-text-btn {
  color: white;
}
</style>